import Vue from "Vue";
import NavigationButtons from "Shared/navigationButtons";
import CartWidget from "Shared/cartWidget";
import ProfileWidget from "Shared/profileWidget";
import SearchWidget from "Shared/searchWidget";
import SearchControl from "Shared/searchControl";
import CartModal from "Shared/cartModal";
import AddComparisonToast from "Shared/addComparisonToast";
import FeedbackModal from "Shared/feedbackModal";

import Vuex from "Vuex";
import { namespace as userStoreNamespace, store as userStore } from "User/store/store";
import { namespace as cartStoreNamespace, store as cartStore } from "Cart/store/store";
import { namespace as compareNamespace, store as compareStore } from "Compare/store/store";

import CartStateModel from "Cart/store/models/stateModel";

Vue.use(Vuex);

export default class BasePage {
	constructor() {
		this.store = new Vuex.Store({
			modules: {
				[userStoreNamespace]: userStore,
				[compareNamespace]: compareStore
			},
			strict: false
		});

		//Всегда должно идти первым
		this._initStorage();

		this._initCartStore();
		this._initializeNavigationButtons(this.store);
		this._initializeCartWidget(this.store);
		this._initializeProfileWidget(this.store);
		this._initializeSearchWidget();
		this._initializeSearchControl();
		this._initializeCartModal(this.store);
		this._initializeComparisonToast();
		this._initializeFeedbackModal(this.store);
	}

	_initializeNavigationButtons(store) {
		try {
			this.navigationButtons = new NavigationButtons(store);
		} catch (ex) {
			console.error(ex);
		}
	}

	_initializeCartWidget(store) {
		try {
			this.cartWidget = new CartWidget(store);
		} catch (ex) {
			console.error(ex);
		}
	}

	_initializeProfileWidget(store) {
		try {
			this.profileWidget = new ProfileWidget(store);
		} catch (ex) {
			console.error(ex);
		}
	}

	_initializeSearchWidget() {
		if (document.getElementById("offcanvas-search") == undefined)
			return;

		try {
			this.SearchWidget = new SearchWidget();
		} catch (ex) {
			console.error(ex);
		}
	}

	_initializeSearchControl() {
		if (document.getElementById("header-search") == undefined)
			return;

		try {
			this.SearchControl = new SearchControl();
		} catch (ex) {
			console.error(ex);
		}
	}

	_initializeCartModal(store) {
		try {
			this.CartModal = new CartModal(store);
		} catch (ex) {
			console.error(ex);
		}
	}

	_initializeComparisonToast() {
		if (document.getElementById("add-comparison-toast") == undefined)
			return;

		try {
			this.AddComparisonToast = new AddComparisonToast();
		} catch (ex) {
			console.error(ex);
		}
	}

	_initializeFeedbackModal(store) {
		if (document.getElementById("vue-feedback-modal") == undefined)
			return;

		try {
			this.FeedbackModal = new FeedbackModal(store);
		} catch (ex) {
			console.error(ex);
		}
	}

	_initStorage() {
		window.Storage.prototype.setObject = function (key, value) {
			this.setItem(key, JSON.stringify(value));
		};

		window.Storage.prototype.getObject = function (key) {
			let value = this.getItem(key);
			return value && JSON.parse(value);
		};

		window.tokenKey = "access_token";
		window.shoppingCartKey = "shoppingCart";
	}

	_initCartStore() {
		let value = localStorage.getItem(window.shoppingCartKey);
		let __INITIAL_STATE__ = value && JSON.parse(value);
		if (__INITIAL_STATE__ === null || __INITIAL_STATE__ === undefined)
			__INITIAL_STATE__ = new CartStateModel({
				comment: null,
				products: new Array()
			});
		else {
			__INITIAL_STATE__.products = __INITIAL_STATE__.products.filter(product => product !== null);
		}

		this.store.registerModule([cartStoreNamespace], {
			...cartStore,
			...{
				state: __INITIAL_STATE__
			}
		});
	}
}